document.addEventListener("DOMContentLoaded", function () {
    const itemsPerPage = 24;

    // Function to show items for the given page
    function showItemsForPage(page) {
        const gridItems = document.querySelectorAll("#product-grid .grid__item");
        const totalItems = gridItems.length;

        const startIndex = (page - 1) * itemsPerPage; // Zero-based index
        const endIndex = Math.min(page * itemsPerPage, totalItems); // Clamp to total items

        gridItems.forEach((item, index) => {
            if (index >= startIndex && index < endIndex) {
                item.style.display = "block"; // Show items in the range
            } else {
                item.style.display = "none"; // Hide items outside the range
            }
        });

        // console.log(`Showing items ${startIndex + 1} to ${endIndex}`);
    }

    // Function to update the URL with the current custom_page parameter
    function updateUrlParameter(page) {
        const url = new URL(window.location);
        url.searchParams.set("custom_page", page);
        window.history.replaceState({}, "", url); // Update the URL without reloading
    }

    // Function to highlight the active pagination link
    function highlightActivePage(page) {
        const paginationItems = document.querySelectorAll(".pagination__item");
        paginationItems.forEach((item) => {
            const itemPage = parseInt(item.getAttribute("data-page"));
            if (itemPage === page) {
                item.classList.add("pagination__item--current");
            } else {
                item.classList.remove("pagination__item--current");
            }
        });
    }

    // Integrate with facets.js renderPage
    const originalRenderPage = FacetFiltersForm.renderPage;
});
